import styled, { css } from 'styled-components';
import Spinner, { SpinnerText } from '@anwb/spinner';
import { pxToRem } from '@anwb/style-utilities';
const SPINNER_TOP = '35%';
export const formContainerStyles = ({ theme, $isLoading, }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		gap: ${pxToRem(theme.spacing['300'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		gap: ${pxToRem(theme.spacing['400'])};
	}

	${$isLoading &&
    css `
		& > *:not(${FormSpinner}) {
			user-select: none;
			pointer-events: none;
			transition: opacity 0.2s;
			opacity: 0.3;
		}
	`}
`;
export const FormContainer = styled.form `
	${formContainerStyles}
`;
/**
 * Form Header
 */
export const formHeaderStyles = ({ theme }) => css `
	position: sticky;
	top: 0;
	z-index: ${theme.zIndex.sticky};
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.blanc.bgSite};

	&&& {
		> * {
			margin-bottom: 0 !important;
		}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		gap: ${pxToRem(theme.spacing['300'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		gap: ${pxToRem(theme.spacing['400'])};
	}
`;
export const FormHeader = styled.header `
	${formHeaderStyles}
`;
/**
 * Form Spinner
 */
export const formSpinnerStyles = () => css `
	position: absolute;
	top: ${SPINNER_TOP};
	left: 50%;
	transform: translateX(-50%);

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const FormSpinner = styled(Spinner) `
	${formSpinnerStyles}
`;
/**
 * Form Footer
 */
export const formFooterStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-direction: row;
		justify-content: space-between;
	}
`;
export const FormFooter = styled.footer `
	${formFooterStyles}
`;
/**
 * Form Footer Primary Content
 */
export const formFooterPrimaryContentStyles = ({ theme }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-left: auto;
		order: 2;
	}
`;
export const FormFooterPrimaryContent = styled.div `
	${formFooterPrimaryContentStyles}
`;
/**
 * Form Footer Secondary Content
 */
export const formFooterAdditionalContentStyles = ({ theme }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		order: 1;
	}
`;
export const FormFooterAdditionalContent = styled.div `
	${formFooterAdditionalContentStyles}
`;
//# sourceMappingURL=form.styled.js.map